module.exports = __webpack_public_path__ + "img/right.1634fae2.svg";